import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";

export default function MusikSuchenResultsCount({ result, results }) {
  return (
    <Grid item xs={6} sm={5}>
      <Typography
        variant="caption"
        sx={{
          textTransform: "uppercase",
          color: grey[600],
          minHeight: "46px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <>
          {result?.length > 0 ? (
            <>
              {results === 1 ? "Ergebnis" : "Ergebnisse"} 1 bis {results}
            </>
          ) : (
            <></>
          )}
        </>
      </Typography>
    </Grid>
  );
}
